class VariantRadiosFourthProduct extends HTMLElement {
  constructor() {
    super();

    window.addEventListener('DOMContentLoaded', this.onLoad.bind(this));
    this.addEventListener('change', this.onVariantChange);
  }

  onLoad() {
    this.activeFirstVariant();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterInput();
    this.toggleAddButton(true, '', false);
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
    } else {
      this.updateVariantInput();
    }
  }

  activeFirstVariant() {
    const firstVariant = this.getVariantData()[0];
    if (!firstVariant) return;

    this.querySelector(`[value="${firstVariant.options[0]}"]`).checked = true;
    this.updateOptions();
    this.updateMasterInput();
    this.updateVariantInput();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  updateMasterInput() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateVariantInput() {
    this.querySelector('.form__label strong').innerText = this.currentVariant.public_title;
    const currentId = this.currentVariant.id;
    if (document.querySelector(`.form__label-selected-value-4`) != null) {
      document.querySelector(`.form__label-selected-value-4`).innerHTML = `<strong>${this.options[0]}</strong>`;
      if (metafieldsArrayFourthProduct && metafieldsArrayFourthProduct.length > 0) {
        metafieldsArrayFourthProduct.forEach(function (variantMetafield) {
          if (variantMetafield.variant_id == currentId) {
            const stockIndex = "stock_" + 0;
            if (variantMetafield[stockIndex] > 0) {
              document.querySelector(`.form__label-selected-value-4`).innerHTML = `<strong> ${document.querySelector(`.form__label-selected-value-4`).innerHTML} </strong> (Plus que 
                  <span class="variant-stock--1">
                    ${variantMetafield[stockIndex]}
                  </span> 
                  en stock)`;
            }
          }
        });
      }
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-radios-fourth-product', VariantRadiosFourthProduct);